/* eslint-disable react-hooks/exhaustive-deps */
// src/pages/LoginPage.js
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import styled from "styled-components";
import { FiMail, FiLock } from "react-icons/fi";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../config";

export const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const { login, logout, token } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Login";

    if (token) {
      logout();
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const endpoint = `${API_BASE_URL}/alterdata_backupsapp/apirest/generate_token`;

      console.log("[LOGIN][DEBUG] Chamando endpoint:", endpoint);

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        body: new URLSearchParams({
          email,
          senha,
          source: "web",
        }).toString(),
      });

      const responseText = await response.text();

      console.log("[LOGIN][DEBUG] URL final:", response.url);
      console.log("[LOGIN][DEBUG] Redirecionou:", response.redirected);
      console.log("[LOGIN][DEBUG] HTTP:", response.status, response.statusText);
      console.log(
        "[LOGIN][DEBUG] Content-Type:",
        response.headers.get("content-type"),
      );
      console.log("[LOGIN][DEBUG] Resposta bruta:", responseText);

      let data;

      try {
        data = JSON.parse(responseText);
      } catch {
        throw new Error(
          `Resposta inválida do servidor. ` +
            `HTTP ${response.status} ${response.statusText}. ` +
            `URL final: ${response.url}. ` +
            `Resposta recebida: ${responseText.substring(0, 1200)}`,
        );
      }

      if (response.ok) {
        login(data.token);

        if (
          Number(data.permission) === 3 &&
          Number(data.first_password_set) === 0
        ) {
          const { isConfirmed } = await Swal.fire({
            title: "Primeiro acesso",
            text: "Você quer manter a senha inicial ou definir uma nova agora?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Definir nova",
            cancelButtonText: "Manter senha inicial",
            reverseButtons: true,
            theme: "dark",
          });

          if (!isConfirmed) {
            const keepRes = await fetch(
              `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/change_own_password.php`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${data.token}`,
                },
                body: JSON.stringify({ keep: true }),
              },
            );
            const keepJson = await keepRes.json();
            if (!keepRes.ok || !keepJson.sucesso) {
              await Swal.fire({
                icon: "error",
                title: "Erro",
                text: keepJson.erro || "Falha ao confirmar senha.",
                theme: "dark",
              });
              return;
            }
            await Swal.fire({
              icon: "success",
              title: "Pronto!",
              text: "Senha inicial mantida.",
              theme: "dark",
            });

            Swal.fire({
              icon: "success",
              title: "Login realizado!",
              showConfirmButton: false,
              timer: 1500,
              theme: "dark",
            });

            navigate("/dashboard");
            return;
          }

          // definir nova
          const { value: formValues } = await Swal.fire({
            title: "Definir nova senha",
            html:
              '<input type="password" id="swal-pass1" class="swal2-input" placeholder="Nova senha">' +
              '<input type="password" id="swal-pass2" class="swal2-input" placeholder="Confirmar nova senha">',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Salvar",
            cancelButtonText: "Cancelar",
            theme: "dark",
            preConfirm: () => {
              const p1 = document.getElementById("swal-pass1").value || "";
              const p2 = document.getElementById("swal-pass2").value || "";
              if (p1.length < 6) {
                Swal.showValidationMessage(
                  "A senha deve ter pelo menos 6 caracteres.",
                );
                return false;
              }
              if (p1 !== p2) {
                Swal.showValidationMessage("As senhas não conferem.");
                return false;
              }
              return { password: p1 };
            },
          });

          if (formValues?.password) {
            const changeRes = await fetch(
              `${API_BASE_URL}/alterdata_backupsapp/apirest/aws/change_own_password.php`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${data.token}`,
                },
                body: JSON.stringify({ new_password: formValues.password }),
              },
            );
            const changeJson = await changeRes.json();
            if (!changeRes.ok || !changeJson.sucesso) {
              await Swal.fire({
                icon: "error",
                title: "Erro",
                text: changeJson.erro || "Falha ao alterar senha.",
                theme: "dark",
              });
              return;
            }
            await Swal.fire({
              icon: "success",
              title: "Sucesso!",
              text: "Senha alterada com sucesso.",
              theme: "dark",
            });
          }
        }

        navigate("/dashboard");
      } else {
        await Swal.fire({
          icon: "error",
          title: `Erro HTTP ${response.status}`,
          text: data.erro || data.message || "Erro desconhecido.",
          theme: "dark",
        });
      }
    } catch (err) {
      console.error("[LOGIN][ERRO COMPLETO]", err);

      Swal.fire({
        icon: "error",
        title: "Erro de conexão",
        text: err?.message || String(err),
        theme: "dark",
      });
    }
  };

  return (
    <Container>
      <LoginBox>
        <Logo style={{ width: "60%" }} src="alterdata_logo.png" alt="Logo" />
        <SubTitle style={{ marginTop: 25 }}>Sistema de Backups</SubTitle>
        <Title>Entrar na Plataforma</Title>
        <Form onSubmit={handleSubmit}>
          <InputGroup>
            <FiMail />
            <Input
              type="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </InputGroup>
          <InputGroup>
            <FiLock />
            <Input
              type="password"
              placeholder="Senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </InputGroup>
          <Button type="submit">Entrar</Button>
        </Form>
      </LoginBox>
    </Container>
  );
};

// Estilização com styled-components
const Container = styled.div`
  background: #0f0f0f;
  color: #fff;
  font-family: "Inter", sans-serif;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubTitle = styled.p`
  text-align: center;
  font-size: 0.9rem;
  color: #aaa;
  margin-top: -0.7rem;
  margin-bottom: 2rem;
`;

const LoginBox = styled.div`
  background: #1a1a1a;
  padding: 3rem;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
`;

const Logo = styled.img`
  width: 150px;
  margin-left: auto;
  margin-right: auto;
  display: block;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 600;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const InputGroup = styled.div`
  background: #2b2b2b;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  margin-bottom: 1.2rem;
  border-radius: 8px;
  svg {
    margin-right: 0.8rem;
  }
`;

const Input = styled.input`
  background: transparent;
  border: none;
  outline: none;
  color: white;
  width: 100%;
  font-size: 1rem;
`;

const Button = styled.button`
  background: #4f46e5;
  color: white;
  padding: 0.75rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
  &:hover {
    background: #3730a3;
  }
`;
